import { omit, get } from 'lodash';
import {
  transformArrayToObject, hasSameValue,
  hasSameValueLoop, // hasBlankName,
} from './config';

export const version = 1.0;

export function validateRouterConfig(routeConfig: any, appFreqList: any) {
  let flag = true;
  const { name } = routeConfig;
  const {
    method, transport, type, idl,
  } = routeConfig.router.upstream;
  const isSetAppFreqLimit = routeConfig.plugins.appFreqLimit.enabled;
  const isSetOAuth = routeConfig.plugins.oauth.enabled;
  const isSetBizAuth = routeConfig.plugins.bizAuth.enabled;
  const isSetApiFreqLimit = routeConfig.plugins.apiFreqLimit.enabled;
  const isSetCache = routeConfig.plugins.cache.enabled;
  const isSetHttpLog = routeConfig.plugins.reqLogger.enabled;

  let newAppFreqList = {};
  // 后端接口 祸端协议
  if (!method || !transport || !name || !type) {
    flag = false;
  }
  // bizrpc 需要协议地址
  if (type === 'bizrpc' && !idl) {
    flag = false;
  }

  // OAuth 权限校验
  if (isSetOAuth) {
    const { cacheDirtyS, cacheExpireS } = routeConfig.plugins.oauth;
    if (!cacheExpireS || !cacheDirtyS) {
      flag = false;
    }
  }
  // 业务权限校验
  if (isSetBizAuth) {
    const {
      cacheDirtyS, cacheExpireS, authBusinessAccountMap, bizType,
    } = routeConfig.plugins.bizAuth;
    if (!cacheExpireS || !cacheDirtyS) {
      flag = false;
    }
    // 广告业务场景校验
    if (bizType === 'advertiser'
      && authBusinessAccountMap
      && (
        Object.keys(authBusinessAccountMap).includes('-1')
        || Object.values<any>(authBusinessAccountMap).map((item) => item.length).includes(0))) {
      flag = false;
    }
  }
  // api频控
  if (isSetApiFreqLimit) {
    if (!routeConfig.plugins.apiFreqLimit.limit) {
      flag = false;
    }
  }
  // APPID频控
  if (isSetAppFreqLimit) {
    const data = transformArrayToObject(appFreqList);
    if (!data) {
      flag = false;
    } else {
      newAppFreqList = data;
    }
  }
  // 缓存权限
  if (isSetCache) {
    if (!routeConfig.plugins.cache.expireS) {
      flag = false;
    }
  }
  // http日志
  if (isSetHttpLog) {
    if (!routeConfig.plugins.reqLogger.maxLogSize) {
      flag = false;
    }
  }

  return {
    isValid: flag,
    appFreqList: newAppFreqList,
  };
}

export function validateApiConfig(store: any) {
  const {
    interfaceDetail, denyList, allowList, interfaceLabel,
  } = store;
  const {
    title, description, rpc, lrQuery, baseSource, reqType,
    reqQuery, reqBody, resBody, reqHeader,
    successCodeList, errorCodeList,
    defaultErrorCode, defaultSuccessCode,
    otherConfig, reqPlugin, resPlugin,
  } = interfaceDetail;

  let apiConfig = {};
  let errMap = codeObjectToObject(defaultErrorCode);
  let successMap = codeObjectToObject(defaultSuccessCode);
  let flag = true;
  if (!title || !description) {
    flag = false;
  }

  // query 参数
  if (reqQuery && reqQuery.length) {
    const has = hasSameValue(reqQuery);
    // const hasBlank = hasBlankName(reqQuery);
    if (!has) {
      flag = false;
    }
  }

  // body 参数
  if (reqBody && reqBody.length) {
    const hasSame = hasSameValueLoop(reqBody);
    // const hasBlank = hasBlankName(reqBody);
    if (!hasSame) {
      flag = false;
    }
  }

  // 返回体
  if (resBody && resBody.length) {
    const hasSame = hasSameValueLoop(resBody);
    // const hasBlank = hasBlankName(resBody);
    // const hasBlankSource = hasBlankName(resBody, 'x-open-source');
    if (!hasSame) {
      flag = false;
    }
  }

  // 成功码
  if (successCodeList && successCodeList.length) {
    successMap = { ...codeArrayToObject(successCodeList), ...successMap };
  }

  // 错误码
  if (errorCodeList && errorCodeList.length) {
    errMap = { ...codeArrayToObject(errorCodeList), ...errMap };
  }

  // apiConfig
  apiConfig = {
    // 补充 配置参数
    ...otherConfig,
    title,
    description,
    xOpenSceneLabels: interfaceLabel,
    xOpenAllowlist: allowList,
    xOpenDenylist: denyList,
    requestContentType: reqType,
    httpHeader: filterId(reqHeader),
    httpQuery: filterId(reqQuery),
    httpBody: filterId(reqBody),
    httpSource: filterId(rpc),
    httpQuerySource: filterId(lrQuery),
    baseSource: filterId(baseSource),
    httpResp: filterId(resBody),
    httpPlugins: {
      beforeRequest: reqPlugin,
      afterResponse: resPlugin,
    },
  };

  return {
    errMap,
    successMap,
    apiConfig,
    isValid: flag,
  };
}

export function codeObjectToArray(object: any) {
  return Object.keys(object).filter((key) => !object[key].default).map((key: string) => ({ serviceCode: key, ...object[key] }));
}
export function getDefaultCode(object: any) {
  let obj: any = null;
  Object.keys(object).forEach((key) => {
    if (object[key].default) {
      obj = { serviceCode: key, ...object[key] };
    }
  });
  return obj;
}
export function codeObjectToObject(object: any = null) {
  if (!object) {
    return {};
  }
  const origin = omit(object, 'serviceCode');
  return {
    [object.serviceCode]: {
      ...origin,
    },
  };
}
/* eslint-disable no-param-reassign */
export function codeArrayToObject(array: any) {
  const origin: any = {};
  array.forEach((item: any) => {
    if (item.serviceCode) {
      const key = item.serviceCode;
      const data = omit(item, 'serviceCode');
      origin[key] = { ...data };
    }
  });
  return origin;
}
// 判断是否存在相同的 name
export function hasSameCode(list: any, code: string) {
  return list.filter((item: any) => item.serviceCode === code).length > 1;
}
// 过滤 id
export function filterId(list: any) {
  function loop(data: any) {
    data.forEach((item: any) => {
      delete item.id;
      if (item.children && item.children.length) {
        loop(item.children);
      }
    });
  }
  loop(list);
  return list;
}

export function createItems(id: string): any {
  return {
    id,
    name: '',
    enum: [],
    type: 'string',
    children: [],
    description: '',
    required: true,
    isExpand: false,
  };
}

export function createObjectItems(id: string): any {
  return {
    id,
    name: '',
    enum: [],
    type: 'object',
    children: [],
    description: '',
    required: true,
    isExpand: false,
  };
}

export function createResItem(id: string): any {
  return {
    id,
    name: '',
    source: '',
    enum: [],
    type: 'string',
    children: [],
    isExpand: true,
    description: '',
  };
}

export function treeForeach(tree: Array<any>, callback: Function) {
  tree.forEach((data, key) => {
    callback(tree, data, key);
    if (data.children) {
      treeForeach(data.children, callback);
    }
  });
}

export function buildAllowOrDenyList(list: any) {
  const appId = get(list, 'appId.ids', []);
  const advertiserId = get(list, 'advertiserId.ids', []);
  const developerId = get(list, 'developerId.ids', []);
  const result = [];
  if (appId.length) {
    result.push({
      id: 1,
      type: 'appId',
      list: appId,
    });
  }
  if (advertiserId.length) {
    result.push({
      id: 2,
      type: 'advertiserId',
      list: advertiserId,
    });
  }
  if (developerId.length) {
    result.push({
      id: 3,
      type: 'developerId',
      list: developerId,
    });
  }
  return result;
}

export function flatAllowOrDenyList(list: any) {
  const result: any = {};
  list.forEach((item: any) => {
    if (item.list.length) {
      result[item.type] = { ids: item.list };
    }
  });
  return result;
}
